import { Vue, Prop, Component, Ref, Watch } from 'vue-property-decorator';

import AbcDatePicker from "../../date-picker/AbcDatePicker.vue";
import CalendarHeader from "./CalendarHeader.vue";
import { MONTH_NAMES, trunc } from '../../date-picker/private/Utils';
import AButton from "../../date-picker/private/AButton.vue"
import { ViewType } from "../../date-picker/private/Utils";

@Component({
    components: {
        CalendarHeader,
        AbcDatePicker,
        AButton
    },
})
export default class CalendarMixin extends Vue {
    @Ref("title") titleEl!: HTMLElement;

    @Prop() value!: Date | null;
    @Prop() objItems!: { [dt: number]: unknown[] };
    @Prop() refDate!: Date;

    protected position: { left: string; top: string } | null = null;

    protected get monthName(): string {
        return MONTH_NAMES[this.refDate.getMonth()];
    }

    protected showDatePicker = false;

    protected get curDate(){
        return this.value || new Date();
    }

    protected set curDate(val: Date | null){
        this.showDatePicker = false;
        this.$emit("input", val);
    }

    @Watch("showDatePicker")
    protected computePosition() {
        if (!this.showDatePicker) {
            return;
        }
        const rect = this.titleEl.getBoundingClientRect();
        this.position = {
            top: rect.top + "px",
            left: `${rect.left + rect.width / 2 - 111}px`,
        };
    }

    protected navigate(val: number){
        this.showDatePicker = false;
        this.$emit('navigate', val)
    }

    public changeView(view: ViewType){
        this.$emit('change-view', view)
    }


    private trunc(dt: Date){
        return trunc(dt);
    }
}
